import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

export const Pin: FC<SvgIconProps> = props => (
  <SvgIcon viewBox="0 0 12 12" {...props}>
    <g clipPath="url(#clip0_63_753)">
      <path d="M6 -0.019043C8.925 -0.019043 11.25 2.30596 11.25 5.23096C11.25 6.65596 10.725 8.00596 9.675 8.98096C9.6 9.05596 6.6 11.756 6.525 11.831C6.225 12.056 5.775 12.056 5.55 11.831C5.475 11.756 2.4 9.05596 2.4 8.98096C1.35 8.00596 0.825001 6.65596 0.825001 5.23096C0.75 2.30596 3.075 -0.019043 6 -0.019043ZM6 6.73096C6.825 6.73096 7.5 6.05596 7.5 5.23096C7.5 4.40596 6.825 3.73096 6 3.73096C5.175 3.73096 4.5 4.40596 4.5 5.23096C4.5 6.05596 5.175 6.73096 6 6.73096Z" />
    </g>
    <defs>
      <clipPath id="clip0_63_753">
        <rect fill="white" height="12" width="12" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_63_753)">
      <path d="M6 -0.019043C8.925 -0.019043 11.25 2.30596 11.25 5.23096C11.25 6.65596 10.725 8.00596 9.675 8.98096C9.6 9.05596 6.6 11.756 6.525 11.831C6.225 12.056 5.775 12.056 5.55 11.831C5.475 11.756 2.4 9.05596 2.4 8.98096C1.35 8.00596 0.825001 6.65596 0.825001 5.23096C0.75 2.30596 3.075 -0.019043 6 -0.019043ZM6 6.73096C6.825 6.73096 7.5 6.05596 7.5 5.23096C7.5 4.40596 6.825 3.73096 6 3.73096C5.175 3.73096 4.5 4.40596 4.5 5.23096C4.5 6.05596 5.175 6.73096 6 6.73096Z" />
    </g>
    <defs>
      <clipPath id="clip0_63_753">
        <rect fill="white" height="12" width="12" />
      </clipPath>
    </defs>
  </SvgIcon>
);
